import { render } from "./maternity-index.vue?vue&type=template&id=7e0fab84"
import script from "./maternity-index.vue?vue&type=script&lang=js"
export * from "./maternity-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__